import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InitialLoadQuery'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InitialLoadQueryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InitialLoadQueryStore",
			variables: false,
		})
	}
}

export async function load_InitialLoadQuery(params) {
  await initClient()

	const store = new InitialLoadQueryStore()

	await store.fetch(params)

	return {
		InitialLoadQuery: store,
	}
}
